<script setup>
import { computed, toRefs } from 'vue'
import $axios from '@/utils/request'
import { API as $API } from '@/service/apiConfig'
import { Toast } from 'vant'
import { PROPS } from './constant'

const props = defineProps(PROPS)
const {
  isDelegationCode,
  isExpired,
  haveGet,
  acceptDelegation,
  isAcceptDelegation,
  examProgress,
  maximumPprogress,
  codeId
} = toRefs(props)

const emit = defineEmits(['onAcceptDelegation'])

const isStart = computed(() => {
  return (
    isDelegationCode.value &&
    !isExpired.value &&
    !haveGet.value &&
    !acceptDelegation.value &&
    !isAcceptDelegation.value &&
    examProgress.value >= maximumPprogress.value
  )
})

async function onAcceptDelegation() {
  try {
    const params = {
      codeId: codeId.value
    }
    await $axios.get($API.acceptDelegation, {params})
    emit('onAcceptDelegation', true)
  } catch (error) {
    Toast(error?.message)
  }
}
</script>

<template>
  <div class="qxs-flex qxs-flex-align-between qxs-flex-vertical-center progress-box">
    <div class="qxs-flex qxs-flex-vertical-center progress-info">
      <div>解锁进度</div>
      <div class="progress">
        <div class="progress-line" :style="{ width: examProgress + '%' }" />
      </div>
      <div v-if="examProgress < maximumPprogress">{{ examProgress }}%</div>
      <div v-if="examTotalCount">共{{ examTotalCount || 0 }}题</div>
      <div class="score-info">共{{ questAmount }}积分</div>
    </div>
    <div v-if="isStart" class="status-btn" @click="onAcceptDelegation">接受调研</div>
    <div v-if="isExpired && !haveGet" class="status-expired">已过期</div>
    <div v-if="haveGet" class="status-have-get">已领取{{ haveGet }}</div>
  </div>
</template>

<style scoped lang="scss">
.progress-box {
  flex: 1;
  margin-top: 6px;
  color: $text-color-info;
  font-size: $font-size-mini;
  font-weight: 400;
  .progress-info {
    flex: 1;
    margin-right: 10px;
    gap: 5px;
    .progress {
      display: flex;
      align-items: center;
      min-width: 60px;
      max-width: 150px;
      flex: 1;
      background: #f0f0f0;
      border-radius: 5px;
      height: 10px;
      margin-left: 3px;
      padding: 0;
      position: relative;
      .progress-line {
        background-color: $color-assist-light;
        border-radius: 4px;
        height: 8px;
        transition: all 200ms cubic-bezier(0.17, 0.86, 0.73, 0.14);
        position: absolute;
      }
    }
    .score-info {
      margin-left: auto;
      color: #ff7600;
    }
  }
  .status-btn,
  .status-expired,
  .status-have-get {
    font-size: 12px;
    color: #fff;
    padding: 3px 10px;
    background: #3d61e3;
    border-radius: 2px;
  }
  .status-expired {
    flex-shrink: 0;
    background: #c4c4c4;
  }
  .status-have-get {
    background: #d9e1f9;
    color: #3d61e3;
  }
}
</style>
